import { render } from "./confirmAgence.vue?vue&type=template&id=21b83c8c&scoped=true"
import script from "./confirmAgence.vue?vue&type=script&lang=js"
export * from "./confirmAgence.vue?vue&type=script&lang=js"

import "./confirmAgence.vue?vue&type=style&index=0&id=21b83c8c&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b83c8c"]])

export default __exports__